export default __webpack_public_path__ + "../images/slider-4.png";